import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PricingCalculator } from '../../components/pricing-calculator/pricing-calculator';
import { FadeInOnViewDirective } from '../../directives/fade-in-on-view.directive';

@Component({
  selector: 'app-landing-page',
  imports: [CommonModule, ButtonModule, FadeInOnViewDirective, TranslateModule, PricingCalculator],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent {
  private readonly router: Router = inject(Router);

  scrollToContent(): void {
    const el = document.getElementById('how-it-works');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }

  onGetInTouch(): void {
    this.router.navigate(['/contact']);
  }
}
